export function convertToEt(timestamp: number | string, yearFirst?: boolean): string {
  const ts = typeof timestamp === 'string' ? parseInt(timestamp, 10) : timestamp;

  const date = new Date(ts);

  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'America/New_York',
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat('en-US', options);
  const parts = formatter.formatToParts(date);

  const month = parts.find((part) => part.type === 'month')?.value || '';
  const day = parts.find((part) => part.type === 'day')?.value || '';
  const year = parts.find((part) => part.type === 'year')?.value || '';
  const hour = parts.find((part) => part.type === 'hour')?.value || '';
  const minute = parts.find((part) => part.type === 'minute')?.value || '';

  if (yearFirst) return `${year}-${month}-${day} ${hour}:${minute}`;
  return `${month}/${day}/${year} ${hour}:${minute}`;
}
